import { useDialog } from '@works-web/settings/modules/dialog';
import { useLCS } from '@works-web/settings/modules/nds';
import { PageContent } from '@works-web/settings/modules/page';
import { useToast } from '@works-web/settings/modules/toast';
import UnauthorizedScene from '@works-web/settings/scenes/unauthorized';
import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Avatar } from '~/settings/__modules__/component';
import { BlockUsersBiz } from '~/settings/biz/BlockUsersBiz';
import { AppData } from '~/settings/service/CommonService';

export default function BlockUsersSub() {
  useLCS('pcset_message_blockmmbr');
  const { t } = useTranslation();
  const toast = useToast();
  const dialog = useDialog();

  const supportExternalRoom = AppData.DomainConfig.supportExternalRoom;

  const [blockList, loadBlockList] = useState(null);
  const toLoadBlockList = () => {
    BlockUsersBiz.getBlickedContactList().then((result) => {
      loadBlockList(result);
    });
  };
  const unblockContacts = (contactNo) => {
    BlockUsersBiz.unblockContacts(contactNo)
      .then((success) => {
        if (success) {
          toast(t('saved'));
          toLoadBlockList();
        }
      })
      .catch(() => {
        dialog.alert((action) => ({
          title: <Trans i18nKey="error_unknown_title" />,
          description: <Trans i18nKey="error_unknown_description" />,
          [action()]: (close) => {
            close && close();
          },
        }));
      });
  };

  React.useEffect(() => {
    toLoadBlockList();
  }, []);

  const blockListDom =
    blockList &&
    blockList.map((item) => {
      return (
        <tr key={item.worksAtContactNo}>
          <td>
            <div className="member_item">
              <div className="thumbnail">
                <span className="thmb_area">
                  <Avatar
                    imgSrc={BlockUsersBiz.getBlockContactThumbnail(item)}
                    userName={item.nickName}
                    userNo={item.worksAtContactNo}
                  />
                </span>
              </div>
              <div className="infor">
                <div className="name_box">
                  {item.serviceType &&
                    item.serviceType.toLowerCase() == 'line' && (
                      <i className="ico_line">LINE</i>
                    )}
                  {item.serviceType &&
                    item.serviceType.toLowerCase() == 'worksat' && (
                      <i className="ico_works">Line Works</i>
                    )}
                  <strong className="name">{item.nickName}</strong>
                </div>
                <div className="text">
                  {item.organization && (
                    <span className="corp">{item.organization}</span>
                  )}
                </div>
              </div>
            </div>
          </td>
          <td className="manage">
            <div className="task">
              <button
                type="button"
                onClick={() => unblockContacts(item.worksAtContactNo)}
              >
                {t('talk_block_unlock')}
              </button>
            </div>
          </td>
        </tr>
      );
    });

  return (
    <>
      {supportExternalRoom ? (
        <>
          {blockList === null ? null : (
            <PageContent
              title={t('talk_main_blockmanage')}
              parentURL="/settings"
            >
              <div className="lw_table_cover">
                <div className="lw_table_header">
                  <div className="status_area">
                    <span className="text">
                      {t('talk_main_blocktitle')}:
                      <em className="point">{blockList.length}</em>
                    </span>
                  </div>
                </div>
                <table className="lw_table lw_table_head tb_blocked_member">
                  <thead>
                    <tr>
                      <th scope="col">{t('talk_block_name')}</th>
                      <th scope="col" className="manage">
                        {t('talk_block_manage')}
                      </th>
                    </tr>
                  </thead>
                </table>
                <div className="lw_table_scroll">
                  <table
                    className="lw_table tb_blocked_member"
                    style={{ display: blockList.length ? 'table' : 'none' }}
                  >
                    <tbody>{blockListDom}</tbody>
                  </table>
                  <div
                    className="tb_empty"
                    style={{ display: blockList.length ? 'none' : 'block' }}
                  >
                    <strong>{t('talk_block_empty')}</strong>
                  </div>
                </div>
              </div>
            </PageContent>
          )}
        </>
      ) : (
        <UnauthorizedScene />
      )}
    </>
  );
}
